
'use strict';

define('component!Raw',['require','react','create-react-class'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');

  var Raw = ReactCreateClass({
    render: function render() {
      return React.createElement('span', { dangerouslySetInnerHTML: { __html: this.props.children } });
    }
  });

  return Raw;
});
